var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilepage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 5.757 1 3.636 2.464 2.318C3.93 1 6.286 1 11 1C15.714 1 18.071 1 19.535 2.318C20.999 3.636 21 5.758 21 10C21 14.242 21 16.364 19.535 17.682C18.072 19 15.714 19 11 19C6.286 19 3.929 19 2.464 17.682C0.999 16.364 1 14.242 1 10Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14H9M13 6H17M13 10H17M13 14H17M7.4 6H6.6C5.846 6 5.469 6 5.234 6.234C5 6.47 5 6.846 5 7.6V8.4C5 9.154 5 9.531 5.234 9.766C5.47 10 5.846 10 6.6 10H7.4C8.154 10 8.531 10 8.766 9.766C9 9.53 9 9.154 9 8.4V7.6C9 6.846 9 6.469 8.766 6.234C8.53 6 8.154 6 7.4 6Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilepage);
export default __webpack_public_path__ + "static/media/Profilepage.dceb23afe6d0a173f8022bec7faafcb4.svg";
export { ForwardRef as ReactComponent };